import { Chip, SvgIcon, Stack, Paper, Skeleton, Popover } from '@mui/material'
import { IconArrowNarrowRight, IconInfoCircle } from '@tabler/icons-react'
import { InventoryStatus, ModelStatus } from '~/supabase/types'
import { inventoryStatusMap, modelStatusMap } from '~/utils/constants'
import { useState } from 'react'
import { Warning } from '~/features/models/models-list/types'

type Props = {
  status: { type: 'model'; value: ModelStatus } | { type: 'inventory'; value: InventoryStatus }
  isLoading: boolean
  warnings?: Warning[]
}

export const StatusChip = ({ status, isLoading, warnings }: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null)

  const hasWarnings = warnings && warnings.length > 0
  const selectedStatus =
    status.type === 'model' ? modelStatusMap[status.value] : inventoryStatusMap[status.value]
  return (
    <Stack direction="row" spacing={1} useFlexGap sx={{ alignItems: 'center', height: 1 }}>
      <Chip
        label={isLoading ? <Skeleton width="80px" height="20px" /> : selectedStatus.label}
        size="small"
        color={selectedStatus.color}
        icon={
          <SvgIcon fontSize="small">
            <IconInfoCircle />
          </SvgIcon>
        }
        onClick={(e) => {
          setAnchorEl(e.currentTarget)
        }}
        sx={{
          '&:hover': {
            svg: {
              width: 16,
              height: 16,

              transition: 'all 0.2s ease-in-out',
            },
          },
          svg: {
            width: 0,
            height: 0,

            transition: 'all 0.2s ease-in-out',
          },
        }}
        disabled={hasWarnings}
      />

      <Popover open={!!anchorEl} onClose={() => setAnchorEl(null)} anchorEl={anchorEl}>
        <StatusProcess statusMap={status.type === 'model' ? modelStatusMap : inventoryStatusMap} />
      </Popover>
    </Stack>
  )
}

const StatusProcess = ({
  statusMap,
}: {
  statusMap: typeof modelStatusMap | typeof inventoryStatusMap
}) => {
  return (
    <Stack
      spacing={1}
      useFlexGap
      sx={{
        px: 1,
        py: 2,
      }}
      component={Paper}
      elevation={2}
    >
      <Stack
        direction="row"
        spacing={1}
        useFlexGap
        divider={
          <SvgIcon fontSize="small" sx={{ color: 'text.secondary' }}>
            <IconArrowNarrowRight />
          </SvgIcon>
        }
      >
        {Object.entries(statusMap).map(([status, { color, label }]) => (
          <Chip key={status} label={label} size="small" color={color} />
        ))}
      </Stack>
    </Stack>
  )
}
